<template lang="pug">
  .table-view
    .table-view-header
      .table-view-header-title
        h3.text-capitalize {{ [date, "DD-MM-YYYY"] | moment('MMMM YYYY') }}
        b-input-group.table-view-header-filter.mr-2
          template(v-slot:prepend)
            .filter-prepend
              font-awesome-icon(:icon="['fas', 'search']")
          b-form-input(v-model="filter" placeholder="buscar")
        b-select.table-view-header-filter(v-model="filterBusinessId")
          b-select-option(:value="null") -- Seleccione un grupo --
          b-select-option(v-for="group in businessGroups" :value="group.businessesIds") {{ group.name }}
      .table-view-header-actions
        base-date-select(v-model="date" :max-date="getCurrentPeriod()")
    b-table(
      v-if="businessesMonthlyStates"
      :fields="tableFields"
      :items="filteredItems"
      :filter="filter"
      :filter-included-fields="filterOn"
      head-row-variant="light-primary"
      responsive sticky-header="600px"
    )
      template(v-slot:head(name)="scope")
        div(class="text-nowrap") {{scope.label}}
      template(v-slot:head(rut)="{label}")
        div(style="width: 120px;") {{label}}
      template(v-slot:head(actions)="scope")
        | {{scope.label}}
      template(v-slot:cell(name)="{item}")
        router-link(:to="{name:'BusinessDetail', params:{id:item.id} }" style="color: var(--primary);") {{item.name}}
      template(v-slot:cell(rut)="row")
        | {{row.item.rut}}
      template(v-slot:cell(actions)="{item}")
        b-dropdown(
          variant="primary"
          size="sm"
          right
          no-caret
          boundary="viewport"
          class="actions-dropdown"
        )
          template(#button-content)
            .icon-circle
              font-awesome-icon(:icon="['fas', 'ellipsis-h']" style="color: #1C3FAA;")
            span.ml-2 Acciones
          b-dropdown-item(@click="lookPasswords(item)")
            font-awesome-icon(:icon="['fas', 'key']" class="mr-2")
            | Ver Claves
          b-dropdown-item(@click="showSendEmailModal(item.client)")
            font-awesome-icon(:icon="['fas', 'envelope']" class="mr-2")
            | Enviar Correo
          b-dropdown-item(@click="showSendF29Modal(item)")
            font-awesome-icon(:icon="['fas', 'paper-plane']" class="mr-2")
            | Enviar F29
          b-dropdown-item(@click="showReceiveDocumentsModal(item)")
            font-awesome-icon(:icon="['fas', 'file-contract']" class="mr-2")
            | Recepcionar documentos
      template(v-slot:cell()="{item, field}")
        base-service-state-select(
          v-if="item[field.key].state"
          v-model="item[field.key].state"
          @change="updateServiceState(item.id ,$event)"
          :states="field.states"
        )
        base-service-state-select(
          v-else
          placeholder="N/A" 
        )
      template(v-slot:cell(progress)="{item: business}")
        .d-flex
          b-progress.border-secondary(:value="business.progress" style="width: 100px;" variant="secondary")
          .pl-1 {{business.progress}}%
    b-modal.modal(
      v-model="showModal"
      ok-only
    )
      template(#modal-title)
        .title(style="display: inline-flex; align-items: center;")
          font-awesome-icon(:icon="['fas', 'key']" size="lg" style="color: #2B3238;margin-right:10px")
          h3 {{business.client.name}}
      template(#modal-ok) Cerrar
      ModalPasswords(:business="business")
    SendEmailFormModal(ref="sendEmailModal")
    SendF29FormModal(ref="sendF29Modal")
    ReceiveDocumentsFormModal(ref="receiveDocumentsModal")
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseServiceStateSelect from './BaseServiceStateSelect'
import BaseDateSelect from '../common/BaseDateSelect'
import ModalPasswords from './ModalPasswords.vue'
import SendEmailFormModal from '../common/SendEmailFormModal'
import SendF29FormModal from '../common/SendF29FormModal'
import ReceiveDocumentsFormModal from '../common/ReceiveDocumentsFormModal'

export default {
  components: {
    BaseServiceStateSelect,
    BaseDateSelect,
    ModalPasswords,
    SendEmailFormModal,
    SendF29FormModal,
    ReceiveDocumentsFormModal
  },
  data () {
    return {
      filterBusinessId: null,
      date: this.getCurrentPeriod(),
      filter: '',
      filterOn: ['name', 'rut'],
      showModal: false,
      business: {}
    }
  },
  methods: {
    ...mapActions(['listServices', 'listBusiness', 'listBusinessGroups']),
    ...mapActions('MonthlyStates',['getMonthlyStates', 'updateBusinessServiceStates']),
    ...mapMutations('MonthlyStates', ['SET_BUSINESSES_MONTHLY_STATES', 'SET_BUSINESSES_MONTHLY_STATES_FROM_WEBSOCKET']),
    updateServiceState (businessId, serviceState) {
      const { id: stateId, value, serviceId } = serviceState
      const optionalValue = value ? value : null
      const data = { businessId, stateId, optionalValue, serviceId}
      const date = this.$moment(this.date, 'DD-MM-YYYY')

      this.updateBusinessServiceStates({ data, year: date.year(), month: date.month() + 1 })
    },
    getCurrentPeriod () {
      const date = this.$moment()
      if (date.date() < 25) {
        return date.subtract(1, 'M').date(1).format('DD-MM-YYYY')
      }
      return date.date(1).format('DD-MM-YYYY')
    },
    calculateTotalProgress (businesseStates) {
      if (!businesseStates || !Array.isArray(businesseStates.services)) {
        return 0
      }
      let totalProgress = 0
      let countServices = 0
      businesseStates.services.forEach(service => {
        if (service.state) {
          countServices++
          totalProgress += service.state.pctProgress ? service.state.pctProgress : 0
        }
      })

      const result = Math.round(totalProgress / countServices)
      if (isNaN(result)) {
        return 0
      }
      return result
    },
    lookPasswords(business) {
      this.business= business
      this.showModal=true
    },
    showSendEmailModal (business) {
      console.log('Mostrando modal de envío de correo para:', business)
      this.$refs.sendEmailModal.showModal({ defaultEmail: business.contact, businessId: business.id })
    },
    showSendF29Modal (item) {
      console.log('Mostrando modal de envío de F29 para:', item)
      this.$refs.sendF29Modal.showModal({ defaultEmail: item.client.contact, businessId: item.client.id })
    },
    showReceiveDocumentsModal (item) {
      console.log('Mostrando modal de recepción de documentos para:', item)
      this.$refs.receiveDocumentsModal.showModal({ 
        defaultEmail: item.client.contact,
        businessId: item.client.id,
        businessName: item.client.name,
        businessRut: item.client.rut
      })
    }
  },
  computed: {
    ...mapGetters(['services','businesses', 'businessGroups']),
    ...mapGetters('MonthlyStates', ['businessesMonthlyStates']),
    filteredItems () {
      if (this.filterBusinessId) {
        return this.tableItems.filter(i => this.filterBusinessId.includes(i.id))
      }
      return this.tableItems
    },
    tableItems () {
      const items = [...this.businessesMonthlyStates]
      items.map(businesseStates => {
        businesseStates.id = businesseStates.client.id
        businesseStates.name = businesseStates.client.name
        businesseStates.rut = businesseStates.client.rut
        businesseStates.services.map(businessServices => {
          businesseStates[businessServices.name] = businessServices
        })
        businesseStates.passwords.map(businessServices => {
          businesseStates[businessServices.name] = businessServices
        })
        // Añade el progreso total
        businesseStates.progress = this.calculateTotalProgress(businesseStates)
      })
      return items
    },
    activeServices () {
      return this.services.filter(service => {
        if (this.businessesMonthlyStates.length && this.businessesMonthlyStates[0].services.find(ms => ms.id === service.id)) {
          return true
        }
        return false
      })
    },
    tableFields () {
      const fields = [{
        key: 'name',
        label: 'Nombre',
        stickyColumn: true,
        variant: 'light',
        sortable: true
      },
      {
        key: 'rut',
        label: 'Rut',
        sortable: true
      },
      {
        key: 'actions',
        label: 'Acciones'
      }]
      this.activeServices.forEach(service => {
        fields.push({ key: service.name, label: service.name,  states: service.states, sortable: true})
      })
      fields.push({ key: 'progress', label: 'Progreso', sortable: true })
      return fields
    }
  },
  watch: {
    // controla la suscripción y desuscripción a eventos del home 
    async date (newValue, oldValue) { 
      const newDate = this.$moment(newValue, 'DD-MM-YYYY')
      await this.getMonthlyStates({ year: newDate.year(), month: newDate.month() + 1 })

      const oldDate = this.$moment(oldValue, 'DD-MM-YYYY')
      this.sockets.unsubscribe(`update state ${oldDate.month() + 1}/${oldDate.year()}`)

      this.sockets.subscribe(`update state ${newDate.month() + 1}/${newDate.year()}`, function(data) {
        this.SET_BUSINESSES_MONTHLY_STATES_FROM_WEBSOCKET({ businessesMonthlyStates: data })
      })
    }
  },
  created () {
    this.listBusinessGroups()
    const date = this.$moment(this.getCurrentPeriod(), 'DD-MM-YYYY')
    const year = date.year()
    const month = date.month() + 1

    this.sockets.subscribe(`update state ${month}/${year}`, function(data) {
      this.SET_BUSINESSES_MONTHLY_STATES_FROM_WEBSOCKET({ businessesMonthlyStates: data })
    })
    this.listServices({ params: { orderBy: 'order' } })
    this.getMonthlyStates({ year, month })
  }
}
</script>
<style lang="scss">
// Estilos globales para el dropdown de acciones (sin scoped para mayor especificidad)
.actions-dropdown {

  
  // Estilos del menú desplegable
  .dropdown-menu {
    z-index: 1050 !important;
    position: fixed !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 0px 0px 8px 8px !important;
    padding: 0.5rem 0 !important;
    min-width: 180px !important;
    background-color: #ffffff !important;
    
    // Estilos de los items del dropdown
    .dropdown-item {
      padding: 0.5rem 1rem !important;
      font-size: 1.15rem !important;
      color: rgba(110, 110, 110, 1) !important;
      transition: all 0.15s ease !important;
      border: none !important;
      display: flex !important;
      align-items: center !important;
      
      &:hover, &:focus {
        background-color: #f8f9fa !important;
        color: #1C3FAA !important;
      }
      
      &:active {
        background-color: #e9ecef !important;
        color: #1C3FAA !important;
      }
      
      // Estilos para los iconos dentro de los items
      .fa, .fas, .far {
        width: 16px !important;
        text-align: center !important;
        color: #6c757d !important;
        transition: color 0.15s ease !important;
      }
      
      &:hover .fa,
      &:hover .fas,
      &:hover .far {
        color: #1C3FAA !important;
      }
    }
    
    // Separador entre items (opcional)
    .dropdown-divider {
      margin: 0.5rem 0 !important;
      border-top: 1px solid #e9ecef !important;
    }
  }
}

// Asegurar que la celda no tenga overflow hidden
.table td {
  overflow: visible !important;
}

// Estilo para el ícono en círculo (scoped para este componente)
.icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  
  .fa, .fas, .far {
    font-size: 0.75rem;
    transition: color 0.2s ease;
  }
}
</style>
